exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-style tbody tr:hover {\n  background-color: #fbb034 !important;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-case-stock/ae-summary-case-stock.component.scss
// module id = ../../../../../src/app/crm/ae-summary-case-stock/ae-summary-case-stock.component.scss
// module chunks = main